import { createQueryKeys } from '@wiggot/libs/react-query'

export const RQKEYS = createQueryKeys('appraisalsService', {
  createAppraisalReport: null,
  getAppraisals: (page?: number, limit?: number) => [page, limit],
  getAppraisal: (id: string) => [id],
  countAllPackages: null
})
